<template>
  <div>
    <button
      type="button"
      class="btn-solar-secondary"
      data-toggle="modal"
      data-target="#exampleModal"
      v-if="filtro == null || filtro"
    >
      <i class="fas fa-search"></i>
      Filtros
    </button>
    <button
      type="button"
      class="btn-solar-secondary ml-2"
      @click="$emit('exportar')"
    >
      <i class="fas fa-download"></i>
      Exportar
    </button>

    <div
      class="modal fade"
      id="exampleModal"
      tabindex="1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="margin-top: 30px; height: 90%;">
        <div class="modal-content" style="height: 100%;">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Filtros</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
              <slot name="body"></slot>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn-solar"
              data-dismiss="modal"
            >
              Aplicar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['filtro']
};
</script>

<style>
.modal-backdrop {
  z-index: -1;
}
</style>